import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoDialogData } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'vfs-wait-dialog',
  templateUrl: './wait-dialog.component.html',
  styleUrls: ['./wait-dialog.component.scss']
})
export class WaitDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WaitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData
  ) {
    this.dialogRef.disableClose = true;
  }

  close() {
    this.dialogRef.close();
  }
}
